export const DeliveryType = [
  'テイクアウト',
  '配達代行',
  '自社配達',
  '店内飲食',
] as const;
export type DeliveryType = typeof DeliveryType[number];

export const IsValidDeliveryType = (item: string): item is DeliveryType => {
  return DeliveryType.includes(item as DeliveryType);
};
